import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowLeftCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM6.68934 12L11 7.68934L12.0607 8.75L9.56066 11.25H17V12.75H9.56066L12.0607 15.25L11 16.3107L6.68934 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftCircle;
